import { z } from 'zod';

export const rawAttributionSchema = z.object({
  adid: z.string(),
  trackerToken: z.string(),
  trackerName: z.string(),
  network: z.string().optional(),
  campaign: z.string().optional(),
  adgroup: z.string().optional(),
  creative: z.string().optional(),
  clickLabel: z.string().optional(),
  attributionState: z.string().optional(),
});

export type RawAttribution = z.infer<typeof rawAttributionSchema>;

export const webAttributionSchema = z.object({
  web_adid: z.string(),
  web_trackerToken: z.string(),
  web_trackerName: z.string(),
  web_network: z.string().optional(),
  web_campaign: z.string().optional(),
  web_adgroup: z.string().optional(),
  web_creative: z.string().optional(),
  web_clickLabel: z.string().optional(),
  web_attributionState: z.string(),
});

export type WebAttribution = z.infer<typeof webAttributionSchema>;

export const appAttributionSchema = z.object({
  adid: z.string(),
  idfa: z.string().optional(),
  idfv: z.string().optional(),
});

export type AppAttribution = z.infer<typeof appAttributionSchema>;
